export const isSupportObjectFit = !!(typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    'objectFit' in document.documentElement.style);
export default isSupportObjectFit;
